type Props = {
  className?: string
  width?: number
  height?: number
  color?: string
  variant?: 'desktop' | 'mobile'
}

const desktopPaths = {
  viewBox: '0 0 105 40.0801',
  width: 105,
  height: 40.0801,
  strokeWidth: 0.961832,
  line: 'M4.10835e-08 19.6884L105 19.6884',
  top: 'M81.7543 0.000356064C81.7543 6.68032 86.3231 20.0402 104.598 20.0402',
  bottom: 'M81.7543 40.0801C81.7543 33.4001 86.323 20.0402 104.598 20.0402',
}

const mobilePaths = {
  viewBox: '0 0 57.0002 26',
  width: 57,
  height: 26,
  strokeWidth: 0.821053,
  line: 'M3.58894e-08 12.7719L57.0002 12.7719',
  top: 'M44.3813 0C44.3813 4.33333 46.8614 13 56.7821 13',
  bottom: 'M44.3813 26C44.3813 21.6667 46.8614 13 56.7821 13',
}

export const HeroArrowIcon = ({ className, width, height, color = 'white', variant = 'desktop' }: Props) => {
  const arrow = variant === 'mobile' ? mobilePaths : desktopPaths

  return (
    <span aria-hidden="true" className={className} data-slot="hero-arrow-icon" data-variant={variant}>
      <svg
        width={width ?? arrow.width}
        height={height ?? arrow.height}
        viewBox={arrow.viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={arrow.line} stroke={color} strokeWidth={arrow.strokeWidth} />
        <path d={arrow.top} stroke={color} strokeWidth={arrow.strokeWidth} />
        <path d={arrow.bottom} stroke={color} strokeWidth={arrow.strokeWidth} />
      </svg>
    </span>
  )
}
